module.exports = __webpack_public_path__ + "168ed329f9fbd430572f711c481cb509.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/blue/adusad.png
// module id = 2665
// module chunks = 0